import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../root-redux/RootState";
import { RequestStatus } from "../../../model/ServiceRequestStatus.model";
import { Helper } from "../utils/Help";
import { QueryBuilderFields, taxonomyExcludeFilters } from "../SPAConstants";

export const taxonomySelector = createSelector(
    (state: RootState) => state.taxonomy,
    (state: RootState) => state.campaignConfig,
    (state: RootState) => state.campaignById,
    (state: RootState) => state.userSalesRoles,
    (state: RootState) => state.filteredCampaign.modelId,
    (taxonomy, config, campaignById, userSalesRoles, selectedModelId): any => {
        const details: {[key:string]: {[key:string]: Set<string>}} = {}

        if (Helper.isLoadingStatus(taxonomy.requestStatus, config.requestStatus, userSalesRoles.requestStatus)) {
            return { taxonomyDetails: details, status: RequestStatus.loading };
        } else if (Helper.isEmpty(taxonomy.taxonomyDetails) || Helper.isEmpty(config.campaignConfig) || Helper.isEmpty(config.campaignConfig?.layoutFields)) {
            return { taxonomyDetails: details, status: RequestStatus.loading };
        }

        const taxonomyDetails = {...taxonomy.taxonomyDetails};

        // if (!userSalesRoles.isSpaAreaPickerOpen && userSalesRoles.isApprover && userSalesRoles.userDetails?.area) {
        //     const layoutConfig = (config.campaignConfig?.layoutFields || []).filter(layout => layout.name === 'Area').at(0);
        //     const territories = (taxonomyDetails['territories'] || []).filter((row: any) => {
        //         return row[layoutConfig?.taxonomyField!] === userSalesRoles.userDetails?.area
        //     });
        //     taxonomyDetails['territories'] = territories;
        // }
        //For FY26, SMC template has both old and new Salesplays and we filter out only new values
         taxonomyDetails['solutionPlayBook'] = (taxonomyDetails['solutionPlayBook'] || []).filter((row: any) => {
            return (row['Org'] === "Enterprise" || row['CurrentFiscalYear'] === 'True');
         });
        taxonomyDetails['solutionPlayBook'] = (taxonomyDetails['solutionPlayBook'] || []).filter((row: any) => {
            const org = (campaignById.summary['CampaignType'] || '');
            const isMultiOrg = org.startsWith("Multi");
            return  (row['MarketingPlay'] == null || row['MarketingPlay'].length === 0) && 
                    (row['SalesPlay'] !== 'Not Applicable') && 
                    (isMultiOrg || row['Org'] === (org.startsWith("Enterprise") ? "Enterprise" : "SMC"));
        });

        const getConfigName = (taxonomyField: string[]|undefined) => {
            return taxonomyField
                ? taxonomyField
                    .map(field => (config.campaignConfig?.layoutFields || []).find(layout => layout.taxonomyField === field)?.name)
                    .filter((name): name is string => name !== undefined)
                : undefined;
        }

        const getFilterKeys = (field: any) => {
            const filterKeys = [...(field.taxonomyFilterKey || [])];
            if (field.taxonomyKey === 'solutionPlayBook'
                && field.name === QueryBuilderFields.Product
                && !filterKeys.includes(QueryBuilderFields.SolutionArea)) {
                filterKeys.unshift(QueryBuilderFields.SolutionArea);
            }
            return filterKeys;
        }

        Object.keys(taxonomyExcludeFilters).forEach(filterKey => {
            const layout = (config.campaignConfig?.layoutFields || []).find(layout => layout.taxonomyKey === filterKey)
            taxonomyDetails[filterKey] = taxonomyDetails[filterKey].filter((options: any) => {
                return !taxonomyExcludeFilters[filterKey].includes(options[(layout && layout.taxonomyField) || 'option']);
            })
        });

        for(const field of (config.campaignConfig?.layoutFields || [])) {
            if (field.taxonomyKey && field.taxonomyField) {
                if (!Object.hasOwn(details, field.taxonomyKey)) {
                    details[field.taxonomyKey] = {};
                }
                details[field.taxonomyKey][field.name] = new Set<string>();
                for(const row of (taxonomyDetails[field.taxonomyKey] || [])) {
                    const filterKeys = getFilterKeys(field);
                    const fieldKey: string[]|undefined = getConfigName(filterKeys);
                    if (window.location.pathname.endsWith('refine') && selectedModelId) {
                        details[field.taxonomyKey][field.name].add(row[field.taxonomyField]);
                    }
                    else if (row[field.taxonomyField] != null && fieldKey && fieldKey.length > 0 && fieldKey.every((key, idx) => row[filterKeys[idx]] === campaignById.summary[key])) {
                        details[field.taxonomyKey][field.name].add(row[field.taxonomyField]);
                    }
                    else if (!(fieldKey || []).some(key => Object.hasOwn(campaignById.summary, key)) && row[field.taxonomyField] != null && (row[field.taxonomyField] || "").length > 0) {
                        details[field.taxonomyKey][field.name].add(row[field.taxonomyField]);
                    }
                }
            }
        }
        
        return { taxonomyDetails: details, status: taxonomy.requestStatus };
    }
);